module.exports = __webpack_public_path__ + "img/keshLogo.1b3a0ef2.svg";